import { Component, PropsWithChildren } from "react";

import { ErrorUnknown } from "./error_unknown";

export class ErrorBoundary extends Component<
  PropsWithChildren<{}>,
  { error?: Error }
> {
  constructor(props: {}) {
    super(props);
    this.state = { error: undefined };
  }

  public componentDidCatch(error: Error): void {
    this.setState({ error });
  }

  public render() {
    return this.state.error ? <ErrorUnknown /> : this.props.children;
  }
}
